import React, { useEffect, useState } from "react";
import ContactCard from "../../component/ContactCard";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import { Timeline, TimelineBlock } from "../../component/Timeline";
import Image from "../../component/Image";
import Rules from "../../component/Rules";
import Pricing from "../../component/Pricing";
import Countdown from "../../component/Countdown";

const rules = [
  "Peserta terdiri dari mahasiswa/i aktif yang berada dalam program pendidikan Diploma (D3/D4) atau Sarjana (S1) dari seluruh Perguruan Tinggi di Indonesia yang dibuktikan dengan menyertakan scan Kartu Tanda Mahasiswa (KTM).",
  "Perlombaan dapat diikuti oleh individu atau tim yang terdiri dari dua orang, di mana satu orang ditunjuk sebagai ketua.",
  "Peserta boleh berasal dari berbagai jurusan selama tetap dari Perguruan Tinggi yang sama.",
  "Peserta yang sudah mendaftar tidak dapat digantikan oleh orang lain.",
  "Peserta diperkenankan untuk mengikuti lebih dari satu jenis perlombaan di ARSEN 2026, tetapi hanya boleh menjadi ketua tim dalam satu jenis perlombaan yang diikuti.",
  "Apabila peserta berhasil lolos ke babak final lebih dari satu cabang perlombaan, maka peserta harus memilih salah satu cabang untuk diikuti.",
  "Peserta tidak diizinkan untuk mendaftar pada dua tim atau lebih untuk perlombaan yang sama.",
  "Peserta wajib mengunggah twibbon ARSEN 2026 di akun Instagram pribadi yang bersifat publik selama kegiatan berlangsung, serta menandai akun Instagram @himasta_unair, @arsenunair, serta tiga akun teman lainnya dengan menggunakan caption dan format yang telah ditentukan panitia melalui tautan berikut: https://bit.ly/TwibbonASICM2026",
  "Peserta yang dinyatakan sah adalah mereka yang telah mendapatkan nomor peserta dari panitia dan menjalani prosedur hingga tuntas.",
  "Peserta yang mengundurkan diri setelah mendaftar tidak dapat meminta pengembalian biaya pendaftaran dan dianggap gugur.",
  "Peserta wajib menjaga etika dan sopan santun dalam seluruh rangkaian kegiatan lomba, baik dalam komunikasi dengan panitia maupun dalam unggahan media sosial.",
  "Peserta wajib mematuhi semua peraturan yang telah ditetapkan oleh panitia, dan jika melanggar, mereka akan dikenakan sanksi sesuai dengan ketentuan yang berlaku.",
];

function AsicMahasiswa() {
  const [isCountdownEnded, setIsCountdownEnded] = useState(false);

  useEffect(() => {


    const targetDate = new Date("2026-08-15T09:00:00+07:00");
    const now = new Date();
    setIsCountdownEnded(now >= targetDate);

    const interval = setInterval(() => {
      const currentTime = new Date();
      setIsCountdownEnded(currentTime >= targetDate);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col gap-3 text-center md:text-left max-w-6xl mx-auto w-full px-5 sm:px-8 mt-8 mb-16">
      <div className="flex items-center flex-col md:flex-row gap-3">
        <div className="flex flex-col gap-3">
          <div data-aos="fade-up">
            <div className="font-bold text-sm tracking-widest text-arsen-primary-500 uppercase">
              CABANG KEGIATAN
            </div>
            <div className="text-5xl md:text-6xl font-bold">
              <span className="text-arsen-primary">A</span>irlangga{" "}
              <span className="text-arsen-primary">S</span>tatistics{" "}
              <span className="text-arsen-primary">I</span>nfographic{" "}
              <span className="text-arsen-primary">C</span>ompetition
            </div>
          </div>
          <div
            data-aos="fade-up"
            data-aos-delay="100"
            className="bg-arsen-primary-100 text-arsen-primary rounded-full md:w-fit px-4 py-1 font-medium text-sm"
          >
            Tingkat Mahasiswa se-Indonesia
          </div>
          <div data-aos="fade-up" data-aos-delay="300">
            <div className="font-bold text-sm tracking-widest text-arsen-primary-500 uppercase">
              TEMA KOMPETISI
            </div>
            <div className="text-sm md:text-lg leading-6 text-gray-700">
              Transforming Global Volatility into Visual Certainty through Data Insight.
            </div>
          </div>
          {isCountdownEnded && (
            <div
              data-aos="fade-up"
              data-aos-delay="400"
              className="flex flex-col md:flex-row gap-2.5 text-md md:text-lg text-center md:text-left text-white mb-8"
            >
              <Link
                to="https://bit.ly/PendaftaranASICM2026"
                target="_blank"
                className="bg-arsen-primary md:w-fit text-center px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:shadow-xl"
              >
                Daftar Sekarang
              </Link>
              <Link
                to="https://bit.ly/GuidebookASICM2026"
                target="_blank"
                className="text-arsen-primary border text-center border-arsen-primary md:w-fit px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:text-white hover:shadow-xl"
              >
                Panduan Kegiatan
              </Link>
              <a
                href="#timeline"
                className="text-arsen-primary border text-center border-arsen-primary md:w-fit px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:text-white hover:shadow-xl"
              >
                Timeline Kompetisi
              </a>
            </div>
          )}
          <div data-aos="fade-up" data-aos-delay="500" className="mt-4">
            <Countdown
              targetDate="2026-08-15T09:00:00+07:00"
              title="Countdown Pembukaan Lomba (15 Agustus 2026 09.00)"
            />
          </div>
        </div>
        <div data-aos="fade-up" className="relative md:ml-4 justify-center">
          <img
            src="/assets/img/logo/asic2026.svg"
            alt="ASIC 2026 Logo"
            width="400"
            className="w-full max-w-[400px] h-auto"
          />
          <img
            src="/assets/img/mascot/mascot1.svg"
            alt=""
            className="absolute bottom-0 -right-2 sm:right-2 w-20 sm:w-24 h-auto"
          />
        </div>
      </div>
      <div className="flex flex-col-reverse md:flex-row gap-6 md:gap-12 md:items-start">
        <div data-aos="zoom-in" className="flex flex-col gap-3 md:flex-1">
          <div className="font-bold text-sm tracking-widest text-arsen-primary-500 uppercase">
            TENTANG KOMPETISI
          </div>
          <div className="text-justify text-gray-700 text-md">
            <span className="font-bold">
              Airlangga Statistics Infographic Competition (ASIC) Tingkat Mahasiswa
            </span>
            <span className="font-normal">
              {" "}merupakan kompetisi infografis tingkat nasional bagi mahasiswa yang menjadi bagian dari rangkaian Airlangga Statistics Event (ARSEN) 2026. Dengan mengangkat tema{" "}
              <b>Transforming Global Volatility into Visual Certainty through Data Insight,</b>{" "}
              kompetisi ini mengajak peserta untuk mengolah data menjadi visualisasi yang informatif, kreatif, dan mudah dipahami sehingga mampu mengubah kompleksitas berbagai isu global menjadi informasi yang lebih jelas dan bermakna. Melalui infografis, peserta diharapkan dapat menyampaikan insight berbasis data secara efektif, menumbuhkan kesadaran terhadap berbagai tantangan di tengah dinamika global, serta menawarkan gagasan dan solusi yang inovatif melalui komunikasi visual yang kuat.
            </span>
          </div>
          <div className="mt-3">
            <Pricing
              color="primary"
              batches={[
                {
                  name: "Batch 1",
                  price: 70000,
                  period: "15 Agustus – 5 September 2026",
                },
                {
                  name: "Batch 2",
                  price: 90000,
                  period: "7 September – 20 September 2026",
                },
              ]}
              note="Dapat diikuti secara individu atau tim yang terdiri dari maksimal 2 orang."
            />
          </div>
        </div>
        <div
          data-aos="zoom-in"
          className="flex w-full flex-col items-center gap-2 md:w-1/3 md:flex-none"
        >
          <div className="font-bold text-sm tracking-widest text-gray-600 uppercase">
            POSTER KEGIATAN
          </div>
          <div className="w-2/3 sm:w-1/2 md:w-full">
            <Image
              src="/assets/img/poster/Poster ASIC MHS 2026.jpg"
              alt="ASIC Mahasiswa Poster"
            />
          </div>
        </div>
      </div>
      <div data-aos="zoom-in" className="flex flex-col gap-3 mb-4">
        <div className="font-bold text-sm tracking-widest text-arsen-primary-500 uppercase">
          Syarat dan Ketentuan
        </div>
        <Rules rules={rules} />
      </div>
      <div className="flex flex-col gap-3" id="timeline">
        <div
          data-aos="zoom-in"
          className="font-bold text-sm tracking-widest text-arsen-primary-500 uppercase"
        >
          TIMELINE KOMPETISI ASIC TINGKAT MAHASISWA
        </div>
        <div className="grid grid-cols-1 gap-x-8 gap-y-2 md:grid-cols-2 lg:grid-cols-3">
          <Timeline month={"Agustus"}>
          <TimelineBlock date="15 Agustus – 5 September 2026">
            Pendaftaran Batch 1
          </TimelineBlock>
          <TimelineBlock date="6 September 2026">
            Technical Meeting 1
          </TimelineBlock>
        </Timeline>
        <Timeline month="September">
          <TimelineBlock date="7 September – 20 September 2026">
            Pendaftaran Batch 2
          </TimelineBlock>
          <TimelineBlock date="21 September – 27 September 2026">
            Pengumpulan Karya
          </TimelineBlock>
        </Timeline>
        <Timeline month="Oktober">
          <TimelineBlock date="11 Oktober – 16 Oktober 2026">
            Pengumuman 15 Karya Terbaik dan Open Likes Karya
          </TimelineBlock>
          <TimelineBlock date="18 Oktober 2026">
            Pengumuman Finalis
          </TimelineBlock>
          <TimelineBlock date="19 Oktober – 21 Oktober 2026">
            Registrasi Ulang Finalis
          </TimelineBlock>
          <TimelineBlock date="24 Oktober 2026">
            Technical Meeting Finalis
          </TimelineBlock>
          <TimelineBlock date="31 Oktober 2026">
            Babak Final & Closing Ceremony
          </TimelineBlock>
        </Timeline>
        </div>
      </div>
      <div data-aos="fade-right" className="flex flex-col gap-4 mt-12 mb-6">
        <div className="font-bold text-sm tracking-widest text-arsen-primary-500 uppercase">
          Informasi Lainnya
        </div>
        {isCountdownEnded && (
          <>
            <div className="flex-col justify-start md:items-start flex">
              <div className="text-center md:text-left text-black text-[32px] font-bold">
                What Are You Waiting For?
              </div>
            </div>
            <div className="flex flex-col md:flex-row gap-2.5 text-sm text-center md:text-left text-white mb-8">
              <Link
                to="https://bit.ly/PendaftaranASICM2026"
                target="_blank"
                className="bg-arsen-primary md:w-fit text-center px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:shadow-xl"
              >
                Pendaftaran
              </Link>
              <Link
                to="https://bit.ly/GuidebookASICM2026"
                target="_blank"
                className="text-arsen-primary border border-arsen-primary md:w-fit px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:text-white hover:shadow-xl"
              >
                Panduan
              </Link>
              <Link
                to="https://bit.ly/PengumpulanKaryaASICM2026"
                target="_blank"
                className="text-arsen-primary border border-arsen-primary md:w-fit px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:text-white hover:shadow-xl"
              >
                Pengumpulan Karya
              </Link>
            </div>
          </>
        )}
      </div>
      <div data-aos="fade-right">
        <ContactCard event="ASIC-Mahasiswa" />
      </div>
    </div>
  );
}

export default AsicMahasiswa;
